<template>
  <label>تصویر</label>

  <div class="relative h-[125px] w-[225px] flex flex-col justify-center overflow-hidden
                    items-center mt-4 border-dashed border-accent rounded-lg cursor-pointer"
       :class="{'border-2' : !(newPhoto || photo)}"
       @click="chooseImage">
    <PlusIcon/>
    <span class="text-accent">افزودن تصویر</span>
    <img :src="newPhoto || photo" alt="" class="absolute h-full w-full" v-if="photo || newPhoto">
  </div>

  <input type="file" name="photo" accept="image/jpeg, image/png"
         @change="onFileChange" ref="input_image" hidden/>
</template>

<script>
import PlusIcon from "@/components/Icons/PlusIcon";

export default {
  name: "VImageInput",
  components: {PlusIcon},
  props: ['photo'],
  data() {
    return {
      newPhoto: ''
    }
  },
  methods: {
    onFileChange(e) {
      let files = e.target.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let vm = this;
      let reader = new FileReader();

      reader.onload = e => {
        console.log(e)
        vm.newPhoto = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    chooseImage() {
      this.$refs.input_image.click()
    }
  }
}
</script>

<style scoped>

</style>